const NAMESPACE = "textValidationRulesTab";

const KEYS = {
    createNewButtonLabel: "createNewButtonLabel",
    nameColumnHeader: "nameColumnHeader",
    ruleTypeColumnHeader: "ruleTypeColumnHeader",
    lastModifiedColumnHeader: "lastModifiedColumnHeader",
    deleteButtonLabel: "deleteButtonLabel",
    editButtonLabel: "editButtonLabel",
    copyButtonLabel: "copyButtonLabel",
    characterSetTypeName: "characterSetTypeName",
    patternMatchTypeName: "patternMatchTypeName",
    createNewTVRModalHeader: "createNewTVRModalHeader",
    editTVRModalHeader: "editTVRModalHeader",
    nameLabel: "nameLabel",
    tvrTypeLabel: "tvrTypeLabel",
    charSetTVRType: "charSetTVRType",
    patternMatchTVRType: "patternMatchTVRType",
    patternMatchInputLabel: "patternMatchInputLabel",
    charSetsInputLabel: "charSetsInputLabel",
    aToZUpperLabel: "aToZUpperLabel",
    aToZLowerLabel: "aToZLowerLabel",
    numericLabel: "numericLabel",
    punctuationLabel: "punctuationLabel",
    maxLengthLabel: "maxLengthLabel",
    enforceMaxLengthSwitchLabel: "enforceMaxLengthSwitchLabel",
    testTVRLabel: "testTVRLabel",
    tvMessage: "tvMessage",
    characterSetDescription: "characterSetDescription",
    patternMatchDescription: "patternMatchDescription",
    savingTVRMessage: "savingTVRMessage",
    patternCharactersHash: "patternCharactersHash",
    patternCharactersUpper: "patternCharactersUpper",
    patternCharactersLower: "patternCharactersLower",
    patternCharactersAnyUpperLower: "patternCharactersAnyUpperLower",
    patternCharactersAnyLetterOrNumber: "patternCharactersAnyLetterOrNumber",
    patternCharactersAnyOther: "patternCharactersAnyOther",
    patternCharactersHeader: "patternCharactersHeader",
    patternCharactersHelpText: "patternCharactersHelpText",
    typesOfTVRMessage: "typesOfTVRMessage",
    emptyTVRTableMessage: "emptyTVRTableMessage",
    addPatternLabel: "addPatternLabel",
    characterSetsRuleDisplay: "characterSetsRuleDisplay",
    patternsDefinedRuleDisplay: "patternsDefinedRuleDisplay",
    maxLengthRuleDisplay: "maxLengthRuleDisplay",
    maxLengthRuleDisplayLabel: "maxLengthRuleDisplayLabel",
    noMaxLengthDefined: "noMaxLengthDefined",
    noPatternsDefined: "noPatternsDefined",
    blockSaveMessageCharSet: "blockSaveMessgeCharSet",
    blockSaveMessagePatternMatch: "blockSaveMessagePatternMatch",
    blockSaveMessagePatternMatchNoneDefined: "blockSaveMessagePatternMatchNoneDefined",
    textValidationRulesTabTitle: "textValidationRulesTabTitle",
    noCharacterSetsMessage: "noCharacterSetsMessage",
    copyingTVRMessage: "copyingTVRMessage",
    deletingTVRMessage: "deletingTVRMessage",
    referencedByDataFields: "referencedByDataFields",
    loadingTextValidationRules: "loadingTextValidationRules",
    textValidationRuleStillHasReferencesDialogTitle: "textValidationRuleStillHasReferencesDialogTitle",
    textValidationRuleReferenceTypeColumnName: "textValidationRuleReferenceTypeColumnName",
    textValidationRuleReferenceNameColumnName: "textValidationRuleReferenceNameColumnName",
    textValidationRuleStillHasReferencesDialogMessage: "textValidationRuleStillHasReferencesDialogMessage",
    referencesTitle: "referencesTitle",
    editingTextValidationRuleTypeDisabled: "editingTextValidationRuleTypeDisabled",
    invalidRuleSchemaConfiguration: "invalidRuleSchemaConfiguration",
    ruleSchemaConfigurationIsValid: "ruleSchemaConfigurationIsValid",
    defaultCharSetValidationError: "defaultCharSetValidationError",
    defaultPatternMatchValidationError: "defaultPatternMatchValidationError",
    validationErrorMessageInfo: "validationErrorMessageInfo",
    validationErrorMessageLabel: "validationErrorMessageLabel",
    defaultErrorMessageLabel: "defaultErrorMessageLabel",
    noneText: "noneText",
    defaultTextTag: "defaultTextTag",
    notApplicable: "notApplicable",
    beginEscapeSequence: "beginEscapeSequence",
    anyOtherCharacter: "anyOtherCharacter",
    descriptionHeader: "descriptionHeader",
    characterSetsWhitespaceInfoMessage: "characterSetsWhitespaceInfoMessage"
};

const MESSAGES = {
    [KEYS.createNewButtonLabel]: {
        value: "New Text Validation Rule",
        comment: "Label for the button that allows users to make new text validation rules"
    },
    [KEYS.nameColumnHeader]: {
        value: "Name",
        comment: "Header for the table column that lists the text validation rule name"
    },
    [KEYS.ruleTypeColumnHeader]: {
        value: "Rule type",
        comment: "Header for the rule type table column"
    },
    [KEYS.lastModifiedColumnHeader]: {
        value: "Last modified",
        comment: "Header for the last modified table column"
    },
    [KEYS.copyButtonLabel]: {
        value: "Copy",
        comment: "Label for the button to create a new copy of an existing text validation rule"
    },
    [KEYS.deleteButtonLabel]: {
        value: "Delete",
        comment: "Label for the button to delete a text validation rule"
    },
    [KEYS.editButtonLabel]: {
        value: "Edit",
        comment: "Label for the button to open the editing modal for a text validation rule"
    },
    [KEYS.characterSetTypeName]: {
        value: "Character set",
        comment: "Text description of character set TVR type name"
    },
    [KEYS.patternMatchTypeName]: {
        value: "Pattern match",
        comment: "Text description of patern match tvr type name"
    },
    [KEYS.editTVRModalHeader]: {
        value: "Edit Text Validation Rule",
        comment: "Header for the edit text validation rule modal"
    },
    [KEYS.createNewTVRModalHeader]: {
        value: "New Text Validation Rule",
        comment: "Header for the create text validation rule modal"
    },
    [KEYS.nameLabel]: {
        value: "Text Validation Rule Name",
        comment: "Label for name input"
    },
    [KEYS.tvrTypeLabel]: {
        value: "Rule type",
        comment: "Label for the radio buttons where the Text Valdiation Rule Type is selected"
    },
    [KEYS.charSetTVRType]: {
        value: "Validate with character sets",
        comment: "Label for the input option for the character sets tvr type"
    },
    [KEYS.patternMatchTVRType]: {
        value: "Validate with text pattern matchings",
        comment: "Label for the input option for the pattern match tvr type"
    },
    [KEYS.patternMatchInputLabel]: {
        value: "Patterns to match",
        comment: "Label for the input where the pattern match is specified"
    },
    [KEYS.charSetsInputLabel]: {
        value: "Allowed character sets",
        comment: "Label for the input to specify which character sets are allowed"
    },
    [KEYS.aToZUpperLabel]: {
        value: "Uppercase letters: A to Z",
        comment: "label for a - z uppercase option"
    },
    [KEYS.aToZLowerLabel]: {
        value: "Lowercase letters: a to z",
        comment: "label for a - z lowercase option"
    },
    [KEYS.numericLabel]: {
        value: "Numeric digits: 0 - 9",
        comment: "label for 0 - 9 digits option"
    },
    [KEYS.punctuationLabel]: {
        value: "Punctuation Characters",
        comment: "Label for punctuation set input option"
    },
    [KEYS.maxLengthLabel]: {
        value: "Maximum input length",
        comment: "Label for the maximum input length input"
    },
    [KEYS.enforceMaxLengthSwitchLabel]: {
        value: "Enforce character limit",
        comment: "Label for the input switch to enable/disable setting maximum input length"
    },
    [KEYS.testTVRLabel]: {
        value: "Rule definition test tool",
        comment: "Label for the input to test a defined text validation rule"
    },
    [KEYS.tvMessage]: {
        value: "A Text Validation Rule ensures input matches the configured rules for text data fields when updated via form entry, data import, web connector, automation action, or API.",
        comment: "Description text for the TVR tab"
    },
    [KEYS.savingTVRMessage]: {
        value: "Saving Text Validation Rule...",
        comment: "Message to display while waiting for text validation rule changes to be saved"
    },
    [KEYS.patternCharactersHash]: {
        value: "Any digit",
        comment: "for demonstrating pattern characters"
    },
    [KEYS.patternCharactersUpper]: {
        value: "Any uppercase letter",
        comment: "for demonstrating pattern characters"
    },
    [KEYS.patternCharactersLower]: {
        value: "Any lowercase letter",
        comment: "for demonstrating pattern characters"
    },
    [KEYS.patternCharactersAnyUpperLower]: {
        value: "Any uppercase or lowercase letter",
        comment: "for demonstrating pattern characters"
    },
    [KEYS.patternCharactersAnyLetterOrNumber]: {
        value: "Any letter or digit",
        comment: "for demonstrating pattern characters"
    },
    [KEYS.anyOtherCharacter]: {
        value: "[Any other character]",
        comment: "or demonstrating pattern characters"
    },
    [KEYS.notApplicable]: {
        value: "N/A",
        comment: "value to go into the escape sequence column for the [any other character] symbol"
    },
    [KEYS.patternCharactersAnyOther]: {
        value: "Only the defined character",
        comment: "for demonstrating pattern characters"
    },
    [KEYS.patternCharactersHeader]: {
        value: "Pattern Character",
        comment: "Header for the key that explains the pattern match characters"
    },
    [KEYS.patternCharactersHelpText]: {
        value: 'If you require one of the pattern characters in the string as itself, and not part of the pattern, then escape it with a backslash. For example, "A" will match any uppercase letter, "\\A" will only allow an uppercase "A".',
        comment: "Help text for the Pattern Character column of the pattern match info table"
    },
    [KEYS.characterSetDescription]: {
        value: "Character Set: Each character in the text input must belong to an allowed character set.",
        comment: "This is an explaination of how the character set tvr rule type works"
    },
    [KEYS.patternMatchDescription]: {
        value: "Pattern match: The text input must match the defined pattern.",
        comment: "This is an explaination of how the character set tvr rule type works"
    },
    [KEYS.typesOfTVRMessage]: {
        value: "There are two types of Text Validation Rules:",
        comment: "Part of the description of TVRs"
    },
    [KEYS.emptyTVRTableMessage]: {
        value: "No Text Validation Rules to show",
        comment: "Message that will show if the TVR table is empty"
    },
    [KEYS.addPatternLabel]: {
        value: "Add Pattern",
        comment: "Label for the button to add a new pattern to the TVR"
    },
    [KEYS.characterSetsRuleDisplay]: {
        value: "Allowed Character Sets:",
        comment: "Label for section of action row that describes the TVR that is defined"
    },
    [KEYS.patternsDefinedRuleDisplay]: {
        value: "Allowed patterns:",
        comment: "Label for section of action row that describes the TVR that is defined"
    },
    [KEYS.maxLengthRuleDisplayLabel]: {
        value: "Character limit:",
        comment: "Label for section of action row that describes the TVR that is defined"
    },
    [KEYS.maxLengthRuleDisplay]: {
        value: "{maxLengthLabel} {maxLength}",
        comment: "Label for section of action row that describes the TVR that is defined"
    },
    [KEYS.noMaxLengthDefined]: {
        value: "No character limit",
        comment: "Message to indicate that a char set rule does not have a max length set"
    },
    [KEYS.noPatternsDefined]: {
        value: "Define a pattern using pattern characters and escape sequences",
        comment: "Message to show if no patterns defined for pattern match TVR"
    },
    [KEYS.blockSaveMessageCharSet]: {
        value: "Select one or more character sets",
        comment: "Message that will show if no character set is selected when save is attempted"
    },
    [KEYS.blockSaveMessagePatternMatch]: {
        value: "Patterns cannot be empty or only contain whitespace",
        comment: "Message that will show if an empty pattern is defined when save is attempted"
    },
    [KEYS.blockSaveMessagePatternMatchNoneDefined]: {
        value: "Define at least one pattern",
        comment: "Message that will show if no pattern is defined when save is attempted"
    },
    [KEYS.textValidationRulesTabTitle]: {
        value: "Text Validation Rules",
        comment: "Title for the text validation rules tab on the datafields page"
    },
    [KEYS.noCharacterSetsMessage]: {
        value: "Select at least one character set",
        comment: "Message that will show if no character sets have been defined for the rule"
    },
    [KEYS.copyingTVRMessage]: {
        value: "Copying Text Validation Rule...",
        comment: "Message to show while waiting for copying TVR to complete"
    },
    [KEYS.deletingTVRMessage]: {
        value: "Deleting Text Validation Rule...",
        comment: "Message to show while waiting for deleting TVR to complete"
    },
    [KEYS.referencedByDataFields]: {
        value: "Referenced by Data Fields",
        comment: "Header for the column that will list what datafields reference the given TVR"
    },
    [KEYS.loadingTextValidationRules]: {
        value: "Loading Text Validation Rules...",
        comment: "Message to show while table is loading the text validation rules"
    },
    [KEYS.textValidationRuleStillHasReferencesDialogTitle]: {
        value: "Unable to delete Text Validation Rule",
        comment: "Title for the dialog that will show if a user attempts to delete a tvr that still has references"
    },
    [KEYS.textValidationRuleReferenceTypeColumnName]: {
        value: "Reference Type",
        comment: "Column name for the type of reference being listed on the references dialog"
    },
    [KEYS.textValidationRuleReferenceNameColumnName]: {
        value: "Reference Name",
        comment: "Column name for the name of the reference being listed on the references dialog"
    },
    [KEYS.textValidationRuleStillHasReferencesDialogMessage]: {
        value: "This Text Validation Rule is still being referenced by Data Fields.",
        comment: "Message for the dialog that will show if a user attempts to delete a tvr that still has references"
    },
    [KEYS.referencesTitle]: {
        value: "Blocking references",
        comment: "Title for the section of the references error dialog where the references are listed."
    },
    [KEYS.editingTextValidationRuleTypeDisabled]: {
        value: "This Text Validation Rule is referenced by multi-line Data Fields which do not support pattern matching.",
        comment:
            "This will show as an info alert next to the disabled tvr type options if a char set tvr has been mapped to a mlt field"
    },
    [KEYS.invalidRuleSchemaConfiguration]: {
        value: "The current Text Validation Rule configuration is not valid. Please correct it before testing your rule.",
        comment:
            " Message that will show up alongside the TVR test box in the edit modal if the currently selected TVR rule schema is not valid"
    },
    [KEYS.ruleSchemaConfigurationIsValid]: {
        value: "Valid Text Validation Rule configuration",
        comment:
            " Message that will show up alongside the TVR test box in the edit modal if the currently selected TVR rule schema is valid"
    },
    [KEYS.defaultCharSetValidationError]: {
        value: "Input contains invalid characters.",
        comment:
            " Default validation error message that will show if a text validation rule doesn't have a validaton error message set"
    },
    [KEYS.defaultPatternMatchValidationError]: {
        value: "Input does not match the expected format.",
        comment:
            "Default validation error message that will show if a text validation rule doesn't have a validaton error message set"
    },
    [KEYS.validationErrorMessageInfo]: {
        value: "This is the red error message users will see if their input is not valid. If empty, then a default validation error message will be shown.",
        comment: "Help text for the pc-alert info about the tvr's ValidationErrorMessage"
    },
    [KEYS.validationErrorMessageLabel]: {
        value: "Validation Error Message:",
        comment: "The label for the validation error message input box"
    },
    [KEYS.defaultErrorMessageLabel]: {
        value: "{defaultText} {message}",
        comment:
            " Label for the spot in the action row where the default validation error message will be shown if no custom validation error message is defined"
    },
    [KEYS.noneText]: {
        value: "None",
        comment:
            " What will display as the allowed character sets in the default char set validation error message if no sets are selected "
    },
    [KEYS.defaultTextTag]: {
        value: "[default]",
        commnet: " This will be used to indicate that the default error message is being used in the tvr action row"
    },
    [KEYS.beginEscapeSequence]: {
        value: "Begin escape sequence",
        comment:
            "Description of the backslash character as being the beginnng of an escape sequence for the pattern match key table"
    },
    [KEYS.descriptionHeader]: {
        value: "Description",
        comment: "Column header for the description column in the pattern match key table on the edit tvr modal"
    },
    [KEYS.characterSetsWhitespaceInfoMessage]: {
        value: "Spaces are valid in all character sets.",
        comment: "Message shown in the info alert for the input where the user selects a character set"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
